export const HALLOWEEN_MSG_KEY = 'halloween_uniqueMsg';

/** Match PHP savedata.php uniqueMsg time: mm:ss from HH:MM:SS. */
export function formatHalloweenMsgTime(time1) {
  const raw = String(time1 || '00:00:00').trim();
  if (raw.includes(':')) {
    const parts = raw.split(':');
    const hours = Number(parts[0]) || 0;
    const minutes = Number(parts[1]) || 0;
    const seconds = Number(parts[2]) || 0;
    const totalMinutes = minutes + hours * 60;
    return `${String(totalMinutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  const total = Math.max(0, Math.floor(Number(raw) || 0));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function halloweenUniqueMsg(score, time) {
  return `Your score is ${score} in ${formatHalloweenMsgTime(time)} minutes.`;
}
